<style lang="scss">




@media screen and (min-width: 55rem) {
  .catbenefit-container {
    margin-top: 5rem;

    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: white;
    .catbenefit {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      background-color: white;

      .catcard-top {
        width: 100%;
        height: 10rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        .catcard-top-subtitle {
          font-size: 1rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #e5004f;
          line-height: 3.25rem;
          text-transform: uppercase;
        }
        .catcard-top-title {
          font-size: 2rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: bold;
          color: #4b4b4b;
        }
        .catcard-top-line {
          width: 2rem;
          height: 0.25rem;
          background-color: #e5004f;
          margin-top: 1rem;
        }
      }
      .cat-list {
        margin-top: 5rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 60%;
        .cat-list-item {
          display: flex;
          flex-direction: column;
          align-items: center;

          .cat-item-title {
            font-size: 1.3125rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 500;
            color: #333333;
            line-height: 1.5625rem;
            margin-top: 1rem;
            margin-bottom: 1rem;
          }

          .cat-item-span {
            font-size: 1rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #0d131a;
          }

          .cat-item-qrcode {
            width: 6rem;
            height: 6rem;
            background-image: url("/media/yintai/membershipcard-1.png");
            background-size: 100% 100%;
          }
          .cat-item-mobile {
            width: 6rem;
            height: 6rem;
            background-image: url("/media/yintai/membershipcard-2.png");
            background-size: 100% 100%;
          }
          .cat-item-gift {
            width: 6rem;
            height: 6rem;
            background-image: url("/media/yintai/membershipcard-3.png");
            background-size: 100% 100%;
          }
        }
        .cat-icon {
          width: 2rem;
          height: 2rem;
          background-image: url("/media/yintai/membership-left.png");
          background-size: 100% 100%;
        }
      }
      .cat-list-2 {
        margin-top: 5rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 80%;
        .cat-list-item {
          display: flex;
          flex-direction: column;
          align-items: center;

          .cat-item-title {
            font-size: 1.3125rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 500;
            color: #333333;
            line-height: 1.5625rem;
            margin-top: 1rem;
            margin-bottom: 1rem;
          }

          .cat-item-span {
            font-size: 1rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #0d131a;
          }

          .cat-item-qrcode {
            width: 6rem;
            height: 6rem;
            background-image: url("/media/yintai/membershipcard-1.png");
            background-size: 100% 100%;
          }
          .cat-item-mobile {
            width: 6rem;
            height: 6rem;
            background-image: url("/media/yintai/membershipcard-2.png");
            background-size: 100% 100%;
          }
          .cat-item-gift {
            width: 6rem;
            height: 6rem;
            background-image: url("/media/yintai/membershipcard-3.png");
            background-size: 100% 100%;
          }
        }
        .cat-icon {
          width: 2rem;
          height: 2rem;
          background-image: url("/media/yintai/membership-left.png");
          background-size: 100% 100%;
        }
      }
    }
  }
}
@media screen and (max-width: 55rem) {
  .catbenefit-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: white;
    margin-top: 2rem;
    .catbenefit {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      background-color: white;
      .catcard-top {
        width: 80%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        .catcard-top-subtitle {
          font-size: 1rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #e5004f;
          line-height: 3.25rem;
          text-transform: uppercase;
        }
        .catcard-top-title {
          font-size: 2rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: bold;
          color: #4b4b4b;
        }
        .catcard-top-line {
          width: 2rem;
          height: 0.25rem;
          background-color: #e5004f;
          margin-top: 1rem;
        }
      }
      .cat-list {
        margin-top: 3rem;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        width: 70%;
        .cat-list-item {
          display: flex;
          flex-direction: column;
          align-items: center;

          .cat-item-title {
            font-size: 1rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 500;
            color: #333333;
            line-height: 1.5625rem;
            margin-top: 1rem;
            margin-bottom: 1rem;
          }

          .cat-item-span {
            display: none;
            // font-size: 1rem;
            // font-family: 'PingFang SC','Microsoft YaHei';
            // font-weight: 400;
            // color: #0d131a;
          }

          .cat-item-qrcode {
            width: 4rem;
            height: 4rem;
            background-image: url("/media/yintai/membershipcard-1.png");
            background-size: 100% 100%;
          }
        }
        .cat-icon {
          width: 2rem;
          height: 2rem;
          background-image: url("/media/yintai/membership-left.png");
          background-size: 100% 100%;
        }
      }
      .cat-list-2 {
        margin-top: 1rem;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        width: 90%;
        .cat-list-item {
          display: flex;
          flex-direction: column;
          align-items: center;

          .cat-item-title {
            font-size: 1rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 500;
            color: #333333;
            line-height: 1.5625rem;
            margin-top: 1rem;
            margin-bottom: 1rem;
          }

          .cat-item-span {
            // font-size: 1rem;
            // font-family: 'PingFang SC','Microsoft YaHei';
            // font-weight: 400;
            // color: #0d131a;
            display: none;
          }

          .cat-item-qrcode {
            width: 4rem;
            height: 4rem;
            background-image: url("/media/yintai/membershipcard-1.png");
            background-size: 100% 100%;
          }
        }
        .cat-icon {
          width: 2rem;
          height: 2rem;
          background-image: url("/media/yintai/membership-left.png");
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>

<template>
  <div class="catbenefit-container">
    <div class="catbenefit">
      <!-- <div class="catcard-top">
        <div class="catcard-top-subtitle">
          INTIME365 MEMBERSHIP BENEFITS
        </div>
        <div class="catcard-top-title">INTIME365会员权益</div>
        <div class="catcard-top-line"></div>
      </div> -->
      <div class="cat-list">
        <div class="cat-list-item">
          <div
            class="cat-item-qrcode"
            style="background-image: url('/media/yintai/carbenefit-1.png')"
          ></div>
          <div class="cat-item-title" style="margin-top: 1rem">邀请赚红包</div>
          <div class="cat-item-span">邀请朋友下载</div>
          <div class="cat-item-span">喵街APP可以得红包</div>
        </div>
        <div class="cat-list-item">
          <div
            class="cat-item-qrcode"
            style="background-image: url('/media/yintai/carbenefit-2.png')"
          ></div>
          <div class="cat-item-title" style="margin-top: 1rem">组队来银泰</div>
          <div class="cat-item-span">邀请朋友下载喵街APP</div>
          <div class="cat-item-span">拼团，人人免费得权益</div>
        </div>
        <!-- <div class="cat-icon"></div> -->
        <div class="cat-list-item">
          <div
            class="cat-item-qrcode"
            style="background-image: url('/media/yintai/carbenefit-3.png')"
          ></div>
          <div class="cat-item-title" style="margin-top: 1rem">東東拼</div>
          <div class="cat-item-span">邀请朋友下载喵街APP</div>
          <div class="cat-item-span">拼团，超级爆款1元购</div>
        </div>
        <div class="cat-list-item">
          <div
            class="cat-item-qrcode"
            style="background-image: url('/media/yintai/carbenefit-4.png')"
          ></div>

          <div class="cat-item-title" style="margin-top: 1rem">每日签到</div>
          <div class="cat-item-span">上喵街APP</div>
          <div class="cat-item-span">领签到红包</div>
        </div>
      </div>
      <div class="cat-list-2">
        <div class="cat-list-item">
          <div
            class="cat-item-qrcode"
            style="background-image: url('/media/yintai/carbenefit-5.png')"
          ></div>

          <div class="cat-item-title" style="margin-top: 1rem">今日秒杀</div>
          <div class="cat-item-span">天天上喵街APP</div>
          <div class="cat-item-span">天天秒杀超级爆款</div>
        </div>
        <div class="cat-list-item">
          <div
            class="cat-item-qrcode"
            style="background-image: url('/media/yintai/carbenefit-6.png')"
          ></div>
          <div class="cat-item-title" style="margin-top: 1rem">
            集口红&天天逛宝柜
          </div>
          <div class="cat-item-span">天天上喵街APP</div>
          <div class="cat-item-span">做任务1元得超级好货</div>
        </div>
        <!-- <div class="cat-icon"></div> -->
        <div class="cat-list-item">
          <div
            class="cat-item-qrcode"
            style="background-image: url('/media/yintai/carbenefit-7.png')"
          ></div>
          <div class="cat-item-title" style="margin-top: 1rem">0元抽奖</div>
          <div class="cat-item-span">天天上喵街APP</div>
          <div class="cat-item-span">0元抽奢侈品</div>
        </div>
        <div class="cat-list-item">
          <div
            class="cat-item-qrcode"
            style="background-image: url('/media/yintai/carbenefit-8.png')"
          ></div>
          <div class="cat-item-title" style="margin-top: 1rem">东东抢</div>
          <div class="cat-item-span">天天上喵街APP</div>
          <div class="cat-item-span">拍超级好货</div>
        </div>
        <div class="cat-list-item">
          <div
            class="cat-item-qrcode"
            style="background-image: url('/media/yintai/carbenefit-9.png')"
          ></div>
          <div class="cat-item-title" style="margin-top: 1rem">全城搜捕</div>
          <div class="cat-item-span">上喵街APP</div>
          <div class="cat-item-span">抢商场优质餐饮、服务</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "catbenefit",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
